import BaseComponent from 'components/pages/ImportedOutgo';
import {
  applyImportedOutgo,
  deleteImportedOutgo,
  deleteImportedOutgoDetail,
  getImportedOutgo,
  patchImportedOutgoDetail,
  postImportedOutgo,
} from 'domains/api/imported_outgos';
import { resetCurrentUser } from 'domains/current_user';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { ImportedOutgo as ImportedOutgoType, ImportedOutgoDetail } from 'types';

const ImportedOutgo: React.FC = () => {
  const navigate = useNavigate();

  const [importedOutgo, setImportedOutgo] = useState<ImportedOutgoType>({
    id: null,
    state: 'created',
    filepath: null,
    details: [],
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    void getImportedOutgo()
      .then((response) => {
        setImportedOutgo(response.imported_outgo);
        setIsLoading(false);
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  }, [navigate]);

  const onClickCsvImport = (fileName: string, content: string) => {
    const params = { file_name: fileName, body: content };

    setIsLoading(true);
    void postImportedOutgo(params)
      .then((response) => {
        setImportedOutgo(response.imported_outgo);
        setIsLoading(false);
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  };

  const onClickUpdateImportedOutgoDetail = (detail: ImportedOutgoDetail) => {
    setIsLoading(true);
    void patchImportedOutgoDetail(detail)
      .then((response) => {
        const updated = { ...importedOutgo };
        const index = updated.details.findIndex(
          (d) => d.id === response.imported_outgo_detail.id,
        );
        updated.details[index].kind = response.imported_outgo_detail.kind;
        updated.details[index].amount = response.imported_outgo_detail.amount;

        setImportedOutgo(updated);
        setIsLoading(false);
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  };

  const onClickDeleteImportedOutgoDetail = (detail: ImportedOutgoDetail) => {
    setIsLoading(true);
    void deleteImportedOutgoDetail(detail)
      .then((_) => {
        const updated = { ...importedOutgo };
        const index = updated.details.findIndex((d) => d.id === detail.id);
        updated.details.splice(index, 1);

        setImportedOutgo(updated);
        setIsLoading(false);
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  };

  const onClickApply = () => {
    setIsLoading(true);
    void applyImportedOutgo().then((_) => {
      navigate('/monthly_balances');
    });
  };

  const onClickDelete = () => {
    setIsLoading(true);
    const targetId = importedOutgo.id;
    if (!targetId) return;

    void deleteImportedOutgo(targetId).then((_) => {
      setImportedOutgo({
        id: null,
        state: 'created',
        filepath: null,
        details: [],
      });
      setIsLoading(false);
    });
  };

  return (
    <BaseComponent
      isLoading={isLoading}
      importedOutgo={importedOutgo}
      onClickCsvImport={onClickCsvImport}
      onClickUpdateImportedOutgoDetail={onClickUpdateImportedOutgoDetail}
      onClickDeleteImportedOutgoDetail={onClickDeleteImportedOutgoDetail}
      onClickApply={onClickApply}
      onClickDelete={onClickDelete}
    />
  );
};

export default ImportedOutgo;
